import script from "./VehicleNewRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleNewRequest.vue?vue&type=script&setup=true&lang=js"

import "./VehicleNewRequest.vue?vue&type=style&index=0&id=4a0e821d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0e821d"]])

export default __exports__